/** The products a customer can hold, one sidebar tab each. Console is Cai staff. */
export enum SidebarTab {
  Insurance = 'insurance',
  Compliance = 'compliance',
  Finance = 'finance',
  Console = 'console',
}

const SIDEBAR_TAB_KEY = 'sidebar-tab'

// Cai admins live in the Console; everyone else starts on the product they bought first.
export const DEFAULT_SIDEBAR_TAB = SidebarTab.Insurance
export const DEFAULT_STAFF_SIDEBAR_TAB = SidebarTab.Console

export function getStoredSidebarTab(): SidebarTab | null {
  const stored = window.localStorage.getItem(SIDEBAR_TAB_KEY)
  const match = Object.values(SidebarTab).find((tab) => tab === stored)
  return match ?? null
}

export function setStoredSidebarTab(tab: SidebarTab): void {
  window.localStorage.setItem(SIDEBAR_TAB_KEY, tab)
}
